export default "__VITE_ASSET__ymg6HwGY__"